import React, { useContext, Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { appContext } from "../context/ContextProvider";
import { useTranslation } from "react-i18next";
import AppButton from "../shared/AppButton";

function ConformationModal({ open, setOpen, onDelete, text = "Delete", isLoading = false }) {
  const { user } = useContext(appContext);
  const { t, i18n } = useTranslation();
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[9999]"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        {/* Backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-2xl transition-all w-full max-w-lg p-4">
                {/* Icon + Message */}
                <div className="flex items-start gap-3">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
                    <ExclamationTriangleIcon
                      className="h-5 w-5 text-red-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="flex-1">
                    <Dialog.Title
                      as="h3"
                      className="text-sm font-bold text-[#1e293b] uppercase tracking-wide"
                    >
                      {t("Alert")}
                    </Dialog.Title>
                    <p className="mt-1 text-sm text-gray-500">
                      {t("Do you want to")}{" "}
                      <span className="font-semibold text-gray-700">
                        {t(text)}
                      </span>
                      ?
                    </p>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="mt-4 flex justify-end gap-2 border-t border-gray-100 pt-3">
                  <AppButton
                    label={t("No")}
                    variant="outlined"
                    onClick={() => setOpen(false)}
                    ref={cancelButtonRef}
                    bgColor="transparent"
                    disabled={isLoading}
                    className="!text-gray-600 !border-gray-300 hover:!bg-gray-50"
                  />
                  <AppButton
                    label={t(text)}
                    onClick={onDelete}
                    bgColor="#dc2626"
                    isLoading={isLoading}
                    loadingText={t("Please wait...")}
                    className="hover:!bg-red-700"
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default ConformationModal;
